import React from 'react';
import { Dialog, Select, Input, FormGroup } from '@tencent/spaui';
import PropTypes from 'prop-types';
import { judgeIsFromTMC } from '../../../utils'
import Role from '../../../consts/Role';
import { RPCFactory } from '../../../utils/RequestUtil';
import { RegexFactory } from '../../../consts/RegexFactory';

const HelpBlockComponent = (props = {}) => {
  const { children, helpBlockClassName = '', helpBlockStyle = {} } = props;
  return (
    <span className={`help-block ${helpBlockClassName}`} style={helpBlockStyle}>
      {children}
    </span>
  );
};

const rolesNeedBindTeam = (role) => {
  const rolesCanBindTeam = [
    Role.OPERATOR_ROLE_LEADS_DATA_ANALYST.getCode(),
    Role.OPERATOR_ROLE_LEADS_CEMPLOYEE_MANAGER.getCode(),
  ];
  return rolesCanBindTeam.indexOf(role) !== -1;
};

class EmployeeDetailPresentationalComponent extends React.Component {
  componentDidMount() {
    this.getUserInfo();
    this.getQRCode();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.userId !== this.props.userId) {
      this.setState(this.getInitValue());
      this.getUserInfo();
    }
  }
  getInitValue = () => {
    return {
      name: '',
      tel: '',
      qq: '',
      wxId: '',
      role: '',
      systemRole: false,
      source: 0,
      loginType: 2,
      loginValue: '',
      nameError: '',
      telError: '',
      loginError: '',
      roleError: '',
      dataRangeError: '',
      loading: false,
      searchValue: '',
      showOnlyCodeDialog: false,
      showCodeDialog: false,
      showTeamChangeDialog: false,
      groupIdNeedConfirm: '',
      userGroupId: '',
      showDataRange: false,
      dataRange: [],
    };
  };
  constructor(props) {
    super(props);
    this.state = this.getInitValue();
  }
  onOnlyCodeDialogCancel = () => {
    this.setState({
      showOnlyCodeDialog: false,
    });
  };

  showOnlyCodeDialogOnClickScan = () => {
    this.setState({
      showOnlyCodeDialog: true,
    });
  };

  handleGroupChange(event, userGroupId) {
    if (this.props.userId) {
      this.setState({
        groupIdNeedConfirm: userGroupId,
        showTeamChangeDialog: true,
      });
    } else {
      const teams = new Set(this.state.dataRange);
      teams.delete(this.state.userGroupId);
      teams.add(userGroupId);
      const dataRange = [...teams];
      this.setState({ userGroupId, dataRange });
    }
  }

  handleTeamChangeConfirm = () => {
    const teams = new Set(this.state.dataRange);
    teams.delete(this.state.userGroupId);
    teams.add(this.state.groupIdNeedConfirm);
    this.setState({
      userGroupId: this.state.groupIdNeedConfirm,
      showTeamChangeDialog: false,
      dataRange: [...teams],
    });
  };
  handleEmployeeTeamChangeClose = () => {
    this.setState({
      groupIdNeedConfirm: '',
      showTeamChangeDialog: false,
    });
  };
  handleGroupSearch(event, value) {
    this.setState({
      searchValue: value,
    });
  }
  getQRCode = () => {
    RPCFactory.accountSettings.createQRCode().done((data) => {
      this.setState({ codeUrl: data.qrCodeUrl });
    });
  };
  getUserInfo = () => {
    if (this.props.userId) {
      RPCFactory.employeeManage
        .getEmployeeById(this.props.userId)
        .done((data) => {
          this.setState({
            name: data.name,
            tel: data.tel,
            qq: data.qq,
            wxId: data.wxId,
            role: data.role,
            userGroupId: data.userGroupId,
            systemRole: data.isSystemRole,
            source: data.source, // 员工来源 0-线索平台 1-讯达 等
            dataRange: data.dataPrivilegeGroupIdList || [],
            showDataRange: rolesNeedBindTeam(data.role),
          });
        })
        .fail((code, msg) => {
          window.alert(`获取员工信息失败，失败信息：${msg}`);
          this.props.onCancel();
        });
    }
  }

  onChangeParameter = (key, value) => {
    if (key === 'role') {
      const showDataRange = rolesNeedBindTeam(value);
      this.setState({ showDataRange, [key]: value });
    } else {
      this.setState({ [key]: value });
    }
  };

  handleDataRangeChange = (e, dataRange) => {
    this.setState({ dataRange });
  };

  onConfirm = (e) => {
    const { name, role, tel, userGroupId, loginType, loginValue, dataRange } = this.state;
    let isValid = true;
    let addqq;
    let addwxId;

    if (!RegexFactory.operationUserNameRegex.test(name)) {
      this.setState({ nameError: '请正确填写员工姓名' });
      isValid = false;
    } else {
      this.setState({ nameError: '' });
    }

    if (!tel || !RegexFactory.operationUserTelRegex.test(tel)) {
      this.setState({ telError: '请正确填写员工电话' });
      isValid = false;
    } else {
      this.setState({ telError: '' });
    }

    if (!this.props.userId) {
      if (loginType == 1) {
        if (!loginValue || !RegexFactory.operationUserQqRegex.test(loginValue)) {
          this.setState({ loginError: '请正确填写员工QQ' });
          isValid = false;
        } else {
          this.setState({ loginError: '' });
          addqq = loginValue;
        }
      } else {
        if (!loginValue || !RegexFactory.operationUserWxIdRegex.test(loginValue)) {
          this.setState({ loginError: '请正确填写员工微信号' });
          isValid = false;
        } else {
          this.setState({ loginError: '' });
          addwxId = loginValue;
        }
      }
    }
    if (userGroupId === '' || typeof userGroupId === 'undefined') {
      this.setState({ userGroupIdError: '请选择所属团队' });
      isValid = false;
    } else {
      this.setState({ userGroupIdError: '' });
    }

    if (role === '' || typeof role === 'undefined') {
      this.setState({ roleError: '请选择角色' });
      isValid = false;
    } else {
      this.setState({ roleError: '' });
    }

    if (rolesNeedBindTeam(role) && dataRange.length < 1) {
      this.setState({ dataRangeError: '请选择可操作的数据范围' });
      isValid = false;
    } else {
      this.setState({ dataRangeError: '' });
    }

    if (!rolesNeedBindTeam(role)) {
      dataRange.length = 0;
    }

    if (isValid) {
      this.setState({ loading: true });
      this.props.onConfirm(this.props.userId, name, loginType, addqq, addwxId, role, tel, userGroupId, dataRange, () => {
        this.setState({ loading: false });
      });
    }
  };

  onCancel = (e) => {
    this.props.onCancel();
  };

  render() {
    const roleItems = [];
    Object.keys(Role).forEach((key) => {
      const role = Role[key];
      if (role == Role.OPERATOR_ROLE_LEADS_OTHER) {
      } else if (role == Role.CUSTOMERROLE_ROOT) {
        if (this.props.userId && this.state.role == Role.CUSTOMERROLE_ROOT.getCode()) {
          roleItems.push({ value: role.getCode(), label: role.getDesc() });
        }
      } else {
        roleItems.push({ value: role.getCode(), label: role.getDesc() });
      }
    });
    const loginTypeItems = [
      { value: 1, label: 'QQ号' },
      { value: 2, label: '微信号' },
    ];
    const addyuangong = {
      width: '580px',
    };
    const help_block = {
      color: 'red',
    };
    const disabledRole = this.state.systemRole || this.state.source === 1;
    const loginSelectShow = this.props.userId ? { display: 'none' } : { display: '' };
    const qqInputShow = this.props.userId && this.state.qq ? { display: '' } : { display: 'none' };
    const wxIdInputShow = this.props.userId && this.state.wxId ? { display: '' } : { display: 'none' };

    const groupList = [];
    for (let i = 0; i < this.props.groupList.length; i++) {
      groupList.push({
        value: this.props.groupList[i].userGroupId,
        label: this.props.groupList[i].userGroupName,
      });
    }
    return (
      <div>
        <Dialog
          type="normal"
          show={this.props.show}
          onClose={this.onCancel}
          onSubmit={this.onConfirm}
          onCancel={this.onCancel}
          backdrop
          title={this.props.userId ? '编辑员工' : '添加员工'}
          disabled={this.state.loading}
          style={{ width: '580px' }}
        >
          <div className="">
            <Dialog
              type="simple"
              cancelButton={false}
              submitButton={false}
              // hideHeader={true}
              headerStyle={{ padding: '0', margin: '0', height: '40' }}
              show={this.state.showOnlyCodeDialog}
              onClose={this.onOnlyCodeDialogCancel.bind(this)}
              style={{ width: '180px' }}
            >
              <div className="QRcode-img">
                <img src={this.state.codeUrl} alt="" style={{ width: '120px' }} />
              </div>
            </Dialog>
            <div className="configs">
              <ul className="config-list">
                <li className="config-li">
                  <p className="name">姓名</p>
                  <div className="form-in">
                    <FormGroup
                      status={this.state.nameError ? 'error' : 'normal'}
                      helpBlock={this.state.nameError}
                      helpBlockClassName="helpblock-test"
                      HelpBlockComponent={HelpBlockComponent}
                    >
                      <Input
                        value={this.state.name}
                        onChange={(event, value) => {
                          this.onChangeParameter('name', value);
                        }}
                        placeholder="请输入姓名"
                      />
                    </FormGroup>
                  </div>
                </li>

                <li className="config-li login-nums-select" style={loginSelectShow}>
                  <p className="name">登录账号</p>
                  <div className="form-in">
                    {
                      judgeIsFromTMC()?<Input style={{ width: '75px', borderTopRightRadius: 0, borderBottomRightRadius: 0 }} disabled={true} value="微信号"/>:
                      <Select
                      data={loginTypeItems}
                      placeholder="请选择登录账号类别"
                      disabled={judgeIsFromTMC()}
                      value={this.state.loginType}
                      onChange={(event, value) => {
                        this.onChangeParameter('loginType', value);
                      }}
                    />
                    }
                    <FormGroup
                      status={this.state.loginError ? 'error' : 'normal'}
                      helpBlock={this.state.loginError}
                      helpBlockClassName="helpblock-test"
                      HelpBlockComponent={HelpBlockComponent}
                    >
                      <Input
                        placeholder={this.state.loginType == 1 ? '请输入QQ号，可用于登录' : '请输入微信号，可用于登录'}
                        value={this.state.loginValue}
                        onChange={(event, value) => {
                          this.onChangeParameter('loginValue', value);
                        }}
                      />
                    </FormGroup>
                  </div>
                  {this.state.loginType == 2 && (
                    <div className="text">
                      绑定员工微信号并让该员工
                      <a
                        href="javascript:void(0)"
                        style={{ fontSize: '14px' }}
                        onClick={this.showOnlyCodeDialogOnClickScan}
                      >
                        扫码
                      </a>
                      绑定公众号，即可让员工及时接收到线索达到及分配提醒。
                    </div>
                  )}
                </li>

                <li className="config-li" style={qqInputShow}>
                  <p className="name">QQ号</p>
                  <div className="form-in">
                    <FormGroup
                      status="normal"
                      helpBlockClassName="helpblock-test"
                      HelpBlockComponent={HelpBlockComponent}
                    >
                      <Input
                        placeholder={'请输入QQ号码，用于系统登录'}
                        disabled={!!this.props.userId}
                        value={this.state.qq}
                        onChange={(event, value) => {
                          this.onChangeParameter('qq', value);
                        }}
                      />
                    </FormGroup>
                  </div>
                </li>

                <li className="config-li" style={wxIdInputShow}>
                  <p className="name">微信号</p>
                  <div className="form-in">
                    <FormGroup
                      status="normal"
                      helpBlockClassName="helpblock-test"
                      HelpBlockComponent={HelpBlockComponent}
                    >
                      <Input
                        placeholder={'请输入微信号码，用于系统登录'}
                        disabled={!!this.props.userId}
                        value={this.state.wxId}
                        onChange={(event, value) => {
                          this.onChangeParameter('wxId', value);
                        }}
                      />
                    </FormGroup>
                  </div>
                </li>

                <li className="config-li">
                  <p className="name">电话号码</p>
                  <div className="form-in">
                    <FormGroup
                      status={this.state.telError ? 'error' : 'normal'}
                      helpBlock={this.state.telError}
                      helpBlockClassName="helpblock-test"
                      HelpBlockComponent={HelpBlockComponent}
                    >
                      <Input
                        placeholder={'请输入电话号码用于电话外呼'}
                        disabled={judgeIsFromTMC() && !!this.props.userId}
                        value={this.state.tel}
                        onChange={(event, value) => {
                          this.onChangeParameter('tel', value);
                        }}
                      />
                    </FormGroup>
                  </div>
                </li>

                <li className="config-li">
                  <p className="name">所属团队</p>
                  <div className="form-in">
                    <FormGroup
                      status={this.state.userGroupIdError ? 'error' : 'normal'}
                      helpBlock={this.state.userGroupIdError}
                      helpBlockClassName="helpblock-test"
                      HelpBlockComponent={HelpBlockComponent}
                    >
                      <Select
                        html
                        search
                        placeholder="请选择所属团队"
                        theNumberOfDisplay={100}
                        data={groupList}
                        searchValue={this.state.searchValue}
                        value={this.state.userGroupId}
                        onChange={this.handleGroupChange.bind(this)}
                        onSearch={this.handleGroupSearch.bind(this)}
                      />
                    </FormGroup>
                  </div>
                </li>

                <li className="config-li">
                  <p className="name">角色</p>
                  <div className="form-in">
                    <FormGroup
                      status={this.state.roleError ? 'error' : 'normal'}
                      helpBlock={this.state.roleError}
                      helpBlockClassName="helpblock-test"
                      HelpBlockComponent={HelpBlockComponent}
                    >
                      <Select
                        placement="auto"
                        disabled={disabledRole}
                        data={roleItems}
                        placeholder="请选择角色"
                        value={this.state.role}
                        onChange={(event, value) => {
                          this.onChangeParameter('role', value);
                        }}
                      />
                    </FormGroup>
                  </div>
                </li>

                {
                  this.state.showDataRange && (
                    <li className="config-li">
                      <p className="name">权限范围</p>
                      <div className="form-in">
                        <FormGroup
                          status={this.state.dataRangeError ? 'error' : 'normal'}
                          helpBlock={this.state.dataRangeError}
                          helpBlockClassName="helpblock-test"
                          HelpBlockComponent={HelpBlockComponent}
                        >
                          <Select
                            html
                            search
                            multiple
                            placeholder="请选择可操作的数据范围"
                            data={groupList}
                            value={this.state.dataRange}
                            onChange={this.handleDataRangeChange.bind(this)}
                          />
                        </FormGroup>
                      </div>
                    </li>
                  )
                }
              </ul>
            </div>
          </div>
        </Dialog>
        <Dialog
          style={{ width: '384px' }}
          type="normal"
          className="employee-change-team-confirm"
          title="确认是否更改团队"
          show={this.state.showTeamChangeDialog}
          onClose={this.handleEmployeeTeamChangeClose.bind(this)}
          onSubmit={this.handleTeamChangeConfirm.bind(this)}
          onCancel={this.handleEmployeeTeamChangeClose.bind(this)}
        >
          <div>
            <p align={'left'}>
              更改该员工所属团队后，该员工的线索也会转移至新团队中，若需要将该员工线索归属至原团队，需先将对应线索分配至团队中其它成员。
            </p>
          </div>
        </Dialog>
      </div>
    );
  }
}

EmployeeDetailPresentationalComponent.propTypes = {
  userId: PropTypes.number,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};
export default EmployeeDetailPresentationalComponent;
